import { Modal } from "react-bootstrap";
import { OrderModel } from "../../../models";
import { OrderStatus } from "../..";
import { useEffect, useState } from "react";
import { GetOrderById } from "../../../services";
import Skeleton from "react-loading-skeleton";

type Props = {
  order: OrderModel;
  show: boolean;
  handleClose: () => void;
  onRefresh: () => void;
};

const OrderStatusModal: React.FC<Props> = ({ order, show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState<OrderModel>();

  useEffect(() => {
    if (show) fetchData();

    return () => setOrderDetail(undefined);
  }, [show, order]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { status, data } = await GetOrderById({
        store_id: order.store_id,
        order_id: order.order_id,
        customer_id: order.customer_id,
      });
      if (status) setOrderDetail(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      className="order_option_popup"
      show={show}
      onHide={handleClose}
      fullscreen="sm-down"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Order Status</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pb-4">
        <div className="thank_sec1">
          {loading && (
            <>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </>
          )}
          {orderDetail && <OrderStatus order={orderDetail} />}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OrderStatusModal;
